<template>
    <div class="v-contact">
        <v-btn
            class="contact-btn gradient-bg large open"
            ref="contactBtn"
            @click="contact_box_show_hide($event)"
        >
            <div class="icon-box">
                <v-icon class="contact-icon">mdi-emoticon-outline</v-icon>
                <v-icon class="close-icon">mdi-close</v-icon>
            </div>
            <span>{{ $TL.ContactUsTips }}</span>
        </v-btn>
        <!-- 联系弹框 -->
        <template>
            <transition name="slideIn">
                <div class="contact-basic-info" ref="basicInfo" v-if="isShow">
                    <div class="box-bg  gradient-bg"></div>
                    <div class="info-content scrollbar" ref="infoContent">
                        <div class="welcome-box" ref="welcomeBox">
                            <h2>{{ $TL.sayHello }} 👋</h2>
                            <p class="call-text">
                                {{ $TL.ContactUsIfHaveQA }}
                            </p>
                        </div>
                        <div class="contact-wrap" ref="contactWrap">
                            <div
                                class="contact-box"
                                v-if="roleName !== 'user-b'"
                            >
                                <p class="instruct">
                                    {{ basicInfoData.contact.skype_message }}
                                </p>
                                <a
                                    :href="basicInfoData.contact.skype"
                                    target="_blank"
                                    class="platform-btn gradient-bg"
                                >
                                    <v-icon>mdi-skype</v-icon>
                                    <span>{{ $TL.contactUs }}</span></a
                                >
                            </div>
                            <div class="contact-box">
                                <p
                                    class="instruct"
                                    v-if="roleName !== 'user-b'"
                                >
                                    {{ basicInfoData.contact.feedback_message }}
                                </p>
                                <a
                                    :href="basicInfoData.contact.feedback"
                                    target="_blank"
                                    class="platform-btn gradient-bg"
                                >
                                    <v-icon>mdi-message-alert</v-icon
                                    ><span>{{ $TL.feedback }}</span></a
                                >
                            </div>
                            <div class="contact-box inst">
                                <div class="inst-list">
                                    <router-link
                                        v-for="(item,
                                        i) in basicInfoData.instructions"
                                        :key="i"
                                        :to="{
                                            name: 'instructions',
                                            query: {
                                                docId: docid_compile(
                                                    item.url.match(
                                                        /d\/(.*?)\/edit/
                                                    )[1]
                                                )
                                            }
                                        }"
                                        target="_blank"
                                        >{{ item.title }}</router-link
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { timeout, set_storage, get_storage, compileStr } from "@/utils/util.js";
export default {
    name: "v-contact",
    props: {
        basicInfoData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            isShow: false,
            roleName: null
        };
    },
    computed: {
        ...mapState("global", ["globalBasicInfo"])
    },
    created() {
        this.roleName = this.globalBasicInfo.roleName;
    },
    async mounted() {
        // this.large_btn_timing();
        await timeout(2200);
        $(".contact-btn").addClass("show");
        await timeout(10000);
        $(".contact-btn").removeClass("large");
    },
    methods: {
        //  信息框滚动效果
        scroll_parallax() {
            let $welcomeBox = $(this.$refs.welcomeBox);
            let update = () => {
                let scrollY = $(this.$refs.infoContent).scrollTop();
                let opacityNum = (1 - scrollY / 100).toFixed(2);
                let opacitys =
                    opacityNum >= 1 ? 1 : opacityNum <= 0 ? 0 : opacityNum;

                $welcomeBox.css({
                    opacity: opacitys,
                    transform: `translateY(${(scrollY / 1.3).toFixed(2)}px)`
                });
            };

            this.$refs.infoContent.addEventListener(
                "scroll",
                () => window.requestAnimationFrame(update),
                false
            );
        },
        contact_box_show_hide(ev) {
            if ($(ev.currentTarget).hasClass("open")) {
                this.open_animate();
                $(ev.currentTarget)
                    .removeClass("open")
                    .addClass("close");
            } else {
                this.close_animate();

                $(ev.currentTarget)
                    .removeClass("close")
                    .addClass("open");
            }
        },
        async open_animate() {
            this.isShow = true;
            await timeout(680);
            this.scroll_parallax();

            $(".contact-box").map((i, el) => {
                $(el)
                    .show()
                    .css({ "transition-delay": `${$(el).index() * 150}ms` });
            });

            $(this.$refs.welcomeBox).animate(
                {
                    opacity: 1
                },
                {
                    step: () => {
                        $(this.$refs.welcomeBox).css({
                            transform: "translateY(0)",
                            transition:
                                "transform 0.35s ease-out, opacity 0.35s ease-out"
                        });
                    },
                    duration: "slow",
                    easing: "swing",
                    complete: () => {
                        this.$refs.infoContent.classList.add("active");
                        $(this.$refs.welcomeBox).css({
                            transition: ""
                        });
                    }
                }
            );
        },
        close_animate() {
            this.isShow = false;
            this.$refs.infoContent.classList.remove("active");
        },
        //  显示大按钮计时
        large_btn_timing() {
            let storeTime = get_storage("largeBtnTime");

            if (storeTime) {
                let nowTime = new Date().getTime();
                let timeDiffer = parseInt(
                    (nowTime - storeTime) / (1000 * 60 * 60)
                );
                if (timeDiffer < 6) {
                    $(".contact-btn").removeClass("large");
                } else {
                    set_storage("largeBtnTime", new Date().getTime());
                }
            } else {
                set_storage("largeBtnTime", new Date().getTime());
            }
        },
        docid_compile(docId) {
            return compileStr(docId);
        }
    }
};
</script>

<style lang="scss">
.v-contact {
    position: fixed;
    right: 16px;
    bottom: 34px;
    z-index: 1020;

    .contact-btn {
        @include flex(center, center);
        padding: 12px 40px 12px 14px;
        background-color: #2874e5;
        border-radius: 50%;
        padding: 8px;
        transition: opacity 1s ease,
            transform 0.5s cubic-bezier(0.24, 0.06, 0, 0.98),
            border-radius 0.3s ease 0.25s;
        box-shadow: 0 3px 6px rgba(#1a73e8, 0.6);
        opacity: 0;
        transform: translateX(60px) scale(0.94);

        &.show {
            opacity: 1;
            transform: translateX(0) scale(1);
        }

        &.large {
            border-radius: 15px;
            padding: 12px 40px 12px 14px;
            .v-btn__content span {
                width: 170px;
                opacity: 1;
                font-size: 18px;
                padding-left: 12px;
            }
        }

        &.open {
            .close-icon {
                transform: scale(0);
            }
            .contact-icon {
                transform: scale(1);
                transition-delay: 0.25s;
            }
        }

        &.close {
            .close-icon {
                transform: scale(1);
                transition-delay: 0.2s;
            }
            .contact-icon {
                transform: scale(0);
            }
        }

        .v-btn__content span {
            width: 0;
            color: $color-white;
            padding-left: 0px;
            transition: width 0.35s ease, opacity 0.2s ease;
            opacity: 0;
        }

        .icon-box {
            width: 38px;
            height: 38px;
            position: relative;
        }

        .v-icon {
            width: 36px;
            height: 36px;
            color: $color-white;
            font-size: 36px;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }

        .close-icon {
            transform: scale(0);
        }
    }

    .contact-basic-info {
        width: 368px;
        height: 520px;
        position: absolute;
        right: 0;
        bottom: 78px;
        z-index: 1000;
        border-radius: 12px;
        background-color: $color-white;
        box-shadow: 0 12px 60px 5px rgb(0 0 0 / 30%);
        overflow: hidden;
    }

    .box-bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        height: 210px;
    }

    .info-content {
        position: relative;
        z-index: 2;
        height: 100%;
        overflow-y: auto;

        &.active {
            .contact-box {
                transform: translateX(0);
                opacity: 1;
            }
        }
    }

    .contact-wrap,
    .welcome-box {
        padding: {
            left: 16px;
            right: 16px;
        }
    }

    .contact-box {
        display: none;
        transition: transform 0.5s ease-out 0s, opacity 0.65s ease-out 0s;
    }

    .welcome-box {
        padding: {
            top: 24px;
            bottom: 16px;
        }
        opacity: 0;
        transform: translateY(60px);

        h2,
        p {
            color: $color-white;
        }

        h2 {
            font-size: 24px;
            margin-bottom: 8px;
        }

        p {
            font-size: 15px;
        }
    }

    .contact-box {
        background-color: $color-white;
        border-radius: 12px;
        padding: 16px;
        overflow: hidden;
        margin-bottom: 16px;
        position: relative;
        box-shadow: 0 3px 6px rgba(#000, 0.16);
        transform: translateX(-80px);
        opacity: 0;

        &::before {
            content: "";
            height: 2px;
            width: 95%;
            border-radius: 2px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: auto;
            @include bgc();
        }

        &.inst {
            padding: {
                top: 8px;
                bottom: 8px;
            }
        }

        .instruct {
            font-size: 14px;
            color: #606368;
            margin-bottom: 16px;
        }

        .inst-list {
            a {
                display: block;
                width: 100%;
                padding: 10px 30px 10px 6px;
                font-size: 14px;
                color: #101010;
                background: {
                    image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjODg4ODg4Ij48cGF0aCBkPSJNMTAsMTdMMTUsMTJMMTAsN1YxN1oiIC8+PC9zdmc+);
                    position: center right;
                    size: auto;
                }

                &:hover {
                    color: #1976d2;
                    background-color: #d6f0ff;
                }
            }
        }

        .platform-btn {
            display: block;
            height: 38px;
            width: 85%;
            margin: auto;
            border-radius: 8px;
            transition: all 0.3s ease;
            @include flex(center, center);
            &:hover {
                box-shadow: 0 2px 8px rgb(26 115 232 / 50%);
            }

            span {
                font-size: 14px;
                color: $color-white;
            }

            i {
                color: $color-white;
                margin-right: 12px;
            }
        }
    }

    .slideIn-enter-active,
    .slideIn-leave-active {
        transition: opacity 0.25s ease-in, height 0.3s ease-out 0.35s;
    }

    .slideIn-enter,
    .slideIn-leave-to {
        opacity: 0;
        height: 460px;
    }
}
</style>
